// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__R1j3n","rootSuccess":"CompleteLink_rootSuccess__2r4Xu","rootFailure":"CompleteLink_rootFailure__b3F27","isDisabled":"CompleteLink_isDisabled__Xff6b"};